import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { faStar } from '@fortawesome/pro-solid-svg-icons';

import { SystemMessage, SystemMessageService } from 'app/core/system-message/system-message-service';
import { RecaptchaService } from 'app/services/recaptcha.service';
import { HelpDeskFeedbackVm } from 'app/shared/generated/Models/Public/HelpDeskFeedbackVm';

@Component({
    selector: 'pcg-help-desk-ticket-feedback',
    templateUrl: './help-desk-ticket-feedback.component.html',
    styleUrls: ['./help-desk-ticket-feedback.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HelpDeskTicketFeedbackComponent {

    formGroup = HelpDeskFeedbackVm.Form;

    starRating: number = 0;
    isError = false;

    stars = document.getElementsByClassName("star-icon");
    faIconName = { faStar };

    isSubmitting = signal<boolean>(false);

    constructor(
        private activatedRoute: ActivatedRoute
        , private httpClient: HttpClient
        , public sm: SystemMessageService
        , private recaptchaService : RecaptchaService
    ) { }

    ngOnInit() {
        this.getFeedback();
    }

    getFeedback() {
        this.httpClient.get(
            `api/HelpDesk/HelpDeskFeedback/GetModel?helpDeskTicketId=${this.activatedRoute.snapshot.params.id}&guid=${this.activatedRoute.snapshot.params.guid}`
        ).subscribe((vm: HelpDeskFeedbackVm) => { 
            this.formGroup.patchValue(vm);
            this.addStars(this.formGroup.controls.rating.value);
        });
    }

    saveForm() {
        this.isError = false;
        if (this.starRating > 0) { this.formGroup.controls.rating.setValue(this.starRating); }
        else {
            this.isError = true;
            return;
        }

        // Submit with reCAPTCHA protection
        this.recaptchaService.submit(
            {
                action: 'saveHelpDeskFeedback',
                apiEndpoint: 'api/HelpDesk/HelpDeskFeedback/Save',
                formGroup: this.formGroup,
                loadingSignal: this.isSubmitting
            },
            {
                onSuccess: (msg: SystemMessage) => {
                    this.sm.setSystemMessage(msg.message, msg.messageClass);
                    if (!msg.isSuccessful) {
                        this.formGroup.controls.rating.setValue(0); 
                        this.addStars(0);
                    } 
                }
            }
        );
    }

    addStars(starNum) {
        this.removeStars();
        for (let i=0; i < starNum; i++) { this.stars[i]?.classList?.add("star-icon-filled"); }
        this.starRating = starNum;
    }

    removeStars() {
        for (let i=0; i < 5; i++) { this.stars[i]?.classList?.remove("star-icon-filled"); }
    }
}
